module.exports = __webpack_public_path__ + "static/img/3.a827612.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/3.png
// module id = 6Wku
// module chunks = 1